import {GetSafeValue} from '../utils/get-safe-value';
import {StringFieldUtil} from '../utils/string-field-util';
import {environment} from "../../environments/environment";
import {SystemConfigUtils} from "../utils/system-config-utils";

export class EmailSetting {
  private _adminEmail: string;
  private _adminPassword: string;
  private _packageEmailTeam: string[];
  private _recipientEmailTeam: string[];
  private _deliveryEmailTeam: string[];

  constructor() {
    this.packageEmailTeam = [];
    this.recipientEmailTeam = [];
    this.deliveryEmailTeam = [];
    this.adminEmail = environment.adminEmail;
    this.adminPassword = environment.adminPassword;
  }

    clone(data: EmailSetting){

    this.adminEmail = data.adminEmail;
    this.adminPassword = data.adminPassword;
    this.packageEmailTeam = data.packageEmailTeam;
    this.recipientEmailTeam = data.recipientEmailTeam;
    this.deliveryEmailTeam = data.deliveryEmailTeam;

  }

  fromJson(data: EmailSetting){
    this.adminEmail = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.adminEmail], null);
    this.adminPassword = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.adminPassword], null);
    this.recipientEmailTeam = GetSafeValue.getSafeValueAsList(data[StringFieldUtil.recipientEmailTeam], [], []);
    this.deliveryEmailTeam = GetSafeValue.getSafeValueAsList(data[StringFieldUtil.deliveryEmailTeam], [], []);
    this.packageEmailTeam = GetSafeValue.getSafeValueAsList(data[StringFieldUtil.packageEmailTeam], [], []);
  }

  get adminEmail(): string {
    return this._adminEmail;
  }

  set adminEmail(value: string) {
    this._adminEmail = value;
  }

  get adminPassword(): string {
    return this._adminPassword;
  }

  set adminPassword(value: string) {
    this._adminPassword = value;
  }

  get packageEmailTeam(): string[] {
    return this._packageEmailTeam;
  }

  set packageEmailTeam(value: string[]) {
    this._packageEmailTeam = value;
  }

  get recipientEmailTeam(): string[] {
    return this._recipientEmailTeam;
  }

  set recipientEmailTeam(value: string[]) {
    this._recipientEmailTeam = value;
  }

  get deliveryEmailTeam(): string[] {
    return this._deliveryEmailTeam;
  }

  set deliveryEmailTeam(value: string[]) {
    this._deliveryEmailTeam = value;
  }

  toMap() {
    if(SystemConfigUtils.getIsSingleStoreBCSetting()) {
      return {
        'adminEmail': this.adminEmail,
        'adminPassword': this.adminPassword,
        'recipientEmailTeam': this.recipientEmailTeam,
        'packageEmailTeam': this.packageEmailTeam,
        'deliveryEmailTeam': this.deliveryEmailTeam
      };
    }

    return {
      'recipientEmailTeam': this.recipientEmailTeam,
      'packageEmailTeam': this.packageEmailTeam,
      'deliveryEmailTeam': this.deliveryEmailTeam
    };
  }

  toMapForDefault() {
    return {
      'adminEmail' : this.adminEmail,
      'adminPassword': this.adminPassword,
    };
  }
}
